export default __webpack_public_path__ + "static/media/attachment.f6168e87.svg";